var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUah(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#43464c",
    fillOpacity: 0.5,
    r: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.824 30.1055-3.4748 2.8292h10.205v3.1285h-13.2339c-.8846.6699-1.4083 1.4894-1.4083 2.5299 0 1.7887 1.4083 2.7579 3.9206 2.7579 2.1443 0 3.9914-1.0404 5.4705-3.1997l4.0692 2.7579c-2.2151 3.4278-6.2135 5.1382-9.9855 5.1382-4.9539 0-8.648-2.3803-8.648-6.3283 0-1.2685.4458-2.6083 1.3304-3.6488h-4.0692v-3.1285h6.5037l3.5526-2.8292h-10.0563v-3.1285h13.1631c.9624-.8908 1.4083-1.7103 1.4083-2.6795 0-1.5607-1.4083-2.6795-3.5526-2.6795-2.0736 0-3.8428 1.1901-5.1025 3.1997l-3.9206-2.6866c2.1443-3.4279 5.6191-5.1382 9.3911-5.1382 5.1024 0 8.4286 2.6795 8.4286 6.3283 0 1.3397-.4459 2.6795-1.1819 3.6487h3.9207v3.1285z",
    fill: "#d3d5d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUah);
export default __webpack_public_path__ + "static/media/UAH.e5ee6a3fc55b22cc494dec3f539c4a71.svg";
export { ForwardRef as ReactComponent };